import React, { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { SpotlightsDashboard } from '../../components/Spotlight/SpotlightsDashboard';
import { useSidebarControl } from '../../hooks/useSidebarControl';

export const Route = createFileRoute('/spotlights/')({
  component: SpotlightsDashboardComponent,
});

function SpotlightsDashboardComponent() {
  const { closeSidebar } = useSidebarControl();

  // Close sidebar when viewing spotlights dashboard
  useEffect(() => {
    closeSidebar();
  }, [closeSidebar]);

  return <SpotlightsDashboard />;
}
